import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { EditorContext } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import { useEditorDraftActions } from '@wix/da-editor-tiptap/pkg/clientDrafts/hooks';
import { CommentEditorSource } from '../redux/types';
import { CommentEditorContext } from '../context';
/**
 * Provides a function that will cancel a comment! Completely! It'll be removed from drafts
 * and we'll close the relevant editor.
 *
 * Relies on all the contexts provided by `<CommentEditorProviders />`,
 * so be sure you have it set up first!
 */ export function useCommentCancelAction({ onCancel } = {}) {
    const { t } = useTranslation();
    const { editorId, editorSource, collapseEditor } = useContext(CommentEditorContext);
    const { ref: editor, isEmpty } = useContext(EditorContext);
    const { removeEditorDraft } = useEditorDraftActions(editorId);
    return useCallback(()=>{
        removeEditorDraft();
        if (editorSource !== CommentEditorSource.Edit && !isEmpty) {
            const cancel = confirm(t('commentbox.editor.cancel.confirm'));
            if (!cancel) {
                return;
            }
            editor === null || editor === void 0 ? void 0 : editor.commands.clearContent();
        }
        collapseEditor();
        onCancel && onCancel();
    }, [
        isEmpty,
        editorSource,
        removeEditorDraft,
        t,
        editor,
        onCancel,
        collapseEditor
    ]);
}

//# sourceMappingURL=useCommentCancelAction.js.map